import { RelatorioBotBI } from "../../../Components/CardsPages/Atendimento/RelatorioBotBI";

export default function RelatorioBotBIHelpDesk() {
    return <RelatorioBotBI dsModuloBI="BIWhatsApp" />;
}
